"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TAB_NAME;
(function(TAB_NAME) {
  TAB_NAME["INSIGHTS"] = "Insights";
  TAB_NAME["AUTO_REMEDIATION"] = "Auto Remediation";
  TAB_NAME["UTILISATION"] = "Utilisation";
  TAB_NAME["UTILISATION_SUMMARY"] = "Utilisation Summary";
  TAB_NAME["SCHEDULES"] = "Schedules";
  TAB_NAME["EVENTS"] = "Events";
  TAB_NAME["EVENTS_SEARCH"] = "Events_Search";
  TAB_NAME["WORKFLOWS"] = "Workflows";
  TAB_NAME["INVENTORY"] = "Inventory";
  TAB_NAME["INVENTORY_GLOBAL"] = "Inventory Global";
})((TAB_NAME = exports.TAB_NAME || (exports.TAB_NAME = {})));
exports.ADOPTION_TEMPLATE_NAME = "tc_template_adoption_workflow";
exports.INSIGHTS_TRIGGER_WORKFLOW_CONFIG = {
  name: "insights trigger workflow",
  group: "trigger-workflows",
  templateId: "9a31959f"
};
var Permissions;
(function(Permissions) {
  Permissions["RUN"] = "run";
  Permissions["DEFAULT"] = "default";
  Permissions["DETAILED_OUTPUT"] = "detailed_output";
})((Permissions = exports.Permissions || (exports.Permissions = {})));
//# sourceMappingURL=constants.js.map
